import http from "@/utils/http";

const $getDownloadCodeList = (data) => http.get('/api/edu/downloadCode/getDownloadCodeList', data); //分页获取下载码列表
const $getDownLoadTimeList = (data) => http.get('/api/downloadCode/getDownLoadTimeList', data); //获取下载时间列表
const $addDownloadCode = (data) => http.put('/api/edu/downloadCode/addDownloadCode', data); //生成下载码
const $getDownloadQr = (data) => http.get('/api/edu/downloadCode/getDownloadQr', data); //根据下载码查询或生成 qrUrl并返回
const $distribute = (data) => http.get('/api/edu/downloadCode/distributeDownloadCode', data); //分发下载码
const $verifyDownloadCode = (data) => http.get('/api/edu/downloadCode/verifyDownloadCode', data); //验证下载码
const $getTimList = (data) => http.get('/api/edu/activecode/getTimList', data); // 获取激活码有效期


export {
    $getDownloadCodeList,
    $getDownLoadTimeList,
    $addDownloadCode,
    $getDownloadQr,
    $distribute,
    $verifyDownloadCode,
    $getTimList
}